<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="fDistributorID" label="经销商">
          <el-select-table
            v-model="query.fDistributorID"
            :label.sync="fNumber"
            search-key="name"
            url="BasicInformation/Distributor/DistributorChoiceEntry"
            label-field="fName"
            value-field="fid"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },

            ]"
          />
        </el-form-item>
        <el-form-item prop="startDate" label="日期">
          <el-date-picker
            v-model="query.startDate"
            type="date"
            placeholder="选择日期"
            size="small"
            style="width: 150px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item prop="endDate" label="至">
          <el-date-picker
            v-model="query.endDate"
            type="date"
            placeholder="选择日期"
            style="width: 150px"
            value-format="yyyy-MM-dd"
            size="small"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fDistributor" label="经销商" />
        <el-table-column prop="fLevelOld" label="原等级" />
        <el-table-column prop="fLevelNew" label="变更等级" />
        <el-table-column prop="fCreateTime" label="变更时间" :formatter="dateFormat" />
        <el-table-column prop="modifyUser" label="变更人" />
        <el-table-column prop="fDes" label="备注" />
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import moment from 'moment'

export default {
  components: {
    ConfirmButton
  },
  data() {
    return {
      query: {
        fDistributorID: null,
        startDate: null,
        endDate: null,

        pageIndex: 1,
        pageSize: 20
      },
      fNumber: '',
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  async mounted() {
    const newtime = await moment(new Date()).format('YYYY-MM-DD')
    this.query.startDate = newtime
    this.query.endDate = newtime
    await this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006008002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/DistributorRecordEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },

    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/DistributorRecordDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
